export default __webpack_public_path__ + "static/media/Saudi_Arabia.896b323f.svg";